import { useDeviceInfo } from '@/composables/useDeviceInfo'
import { createRouter, createWebHistory } from 'vue-router'
import { desktopRoutes } from './desktopRoutes'
import { mobileRoutes } from './mobileRoutes'
import { getBaseUrl } from '@/helpers/env'

const { isMobile } = useDeviceInfo()

export const router = createRouter({
  history: createWebHistory(getBaseUrl()),
  routes: isMobile.value ? mobileRoutes : desktopRoutes,
})
